import { render } from "./AccountStarOutline.vue?vue&type=template&id=1e6e44b2"
import script from "./AccountStarOutline.vue?vue&type=script&lang=js"
export * from "./AccountStarOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__